// extracted by mini-css-extract-plugin
export default {"desktopOnly":"webpack-containers-Review-StudyScreening-TrialExpiryBanner-TrialExpiryBanner-module__desktopOnly"};